import type { ReactNode } from "react";

import { HeroVorgangAttachment } from "./hero-vorgang-attachment";
import { HeroVorgangMessage } from "./hero-vorgang-message";
import { HeroVorgangSystemLog } from "./hero-vorgang-system-log";
import {
  HERO_VORGANG_ACTION_FOOTER_CLEARANCE_PX,
  HERO_VORGANG_THREAD_GAP_PX,
  HERO_VORGANG_THREAD_PADDING_X_PX,
} from "./hero-vorgang-tokens";
import type { HeroVorgangThreadItem } from "./module-inbox-vorgang-data";

export function HeroVorgangThread(props: {
  readonly items: readonly HeroVorgangThreadItem[];
}): ReactNode {
  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        overflowY: "auto",
        overflowX: "hidden",
        padding: `${HERO_VORGANG_THREAD_PADDING_X_PX}px ${HERO_VORGANG_THREAD_PADDING_X_PX}px ${HERO_VORGANG_ACTION_FOOTER_CLEARANCE_PX}px`,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: HERO_VORGANG_THREAD_GAP_PX,
        }}
      >
        {props.items.map((item: HeroVorgangThreadItem) => {
          if (item.kind === "message") {
            return (
              <HeroVorgangMessage
                key={item.message.id}
                message={item.message}
              />
            );
          }
          if (item.kind === "system_log") {
            return (
              <HeroVorgangSystemLog
                key={`log-${item.text}-${item.date}`}
                text={item.text}
                date={item.date}
              />
            );
          }
          return (
            <HeroVorgangAttachment
              key={`att-${item.fileName}`}
              fileName={item.fileName}
            />
          );
        })}
      </div>
    </div>
  );
}
